<template>

    <div class="container" v-if="articleJson">
      <div class="close-container">
        <a
          href="https://www.muala.app/"
          class="close"
          title="wróc do mapy MUALA"
        >
          ×
        </a>
      </div>
      <img
        src="@/assets/muala-logo.png"
        alt="MUALA - map"
        width="88"
        height="88"
        class="mx-auto"
      />

      <h1 v-html="articleJson.body.h1 "></h1>
      <p>
        {{ articleJson.body.wstep }}
      </p>

      <iframe
    :title="articleJson.body.h1"
    :src="`https://www.youtube.com/embed/${articleJson.body.videoId}`"
    :srcdoc="iframeSrcdoc"
    frameborder="0"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    loading="lazy"
    class="video"
    width="560"
    height="315"
  ></iframe>


    <!-- <span v-for="(local, index) in articleJson.locals" :key="index">
      <h2 v-html="local.header"></h2>
      <strong class="mark">&nbsp;{{local.shortDesc}}&nbsp;</strong>
      <p  v-html="local.opis"></p>
    </span> -->
    <div>
      <h2 v-html="articleJson.body.h2"></h2>
      <strong class="mark">&nbsp;{{articleJson.body.shortDesc}}&nbsp;</strong>
      <p v-html="articleJson.body.opis" class="article"></p>
    </div>
      

      <div class="summary">
        <h2>Podsumowanie</h2>
        <p>
          {{articleJson.body.podsumowanie}}
        </p>
      </div>

      <!-- <div class="wystapili" v-if="articleJson.locals.length > 1">
        <h2>Na kulinarnej mapie odcinka</h2>
        <ul>
        {{LOCALS-LINKS}}
        </ul>
      </div> -->
     
    </div>


    <a
      id="all"
      :href="`https://www.muala.app/${computedCity}`"
      title="wróć i zobacz wszystkie na mapie"
      >wróć</a
    > 












</template>

<script setup>
import { ref, onMounted, watchEffect, watch, computed, transformVNodeArgs,} from "vue";

import { useRoute, useRouter } from "vue-router";
import iconOnly from "./components/iconOnly.vue";


// import { generateContent } from '../composables/askLSM.js';

const props = defineProps({
  id: String, // Zadeklaruj, jeśli oczekujesz 'id' jako prop
});


const router = useRouter();
const route = useRoute();



const goBack = () => {
  router.back();
};

const dane = ref({
  id: "",
  title: "",
  city: "",
  author: "",
  videoId: "",
  publishedAt: "",
  timestamp: "",
  type: "",
  isGroup: 0,
  metaDescription:
    "Podążaj za Książulem i Wojkiem do Zapiekanki Adamus Skawina. Odkryj, jakie tajemnice i historie kryją się w odwiedzanych miejscach z MUALA lub bez.",
  metaTitle: "Zapiekanki Adamus - Skawina odkryj z Książulem i Wojkiem | MUALA",
});

const article = ref({
  // id: "",
  // json: "",
  // placeId: "",
  // type: "location",
  // editDate: "",
});


const articleJson = ref();


const metaDane = ref({
  metaDescription:
    "Podążaj za Książulem i Wojkiem do Zapiekanki Adamus Skawina. Odkryj, jakie tajemnice i historie kryją się w odwiedzanych miejscach z MUALA lub bez.",
  metaTitle: "Zapiekanki Adamus - Skawina odkryj z Książulem i Wojkiem | MUALA",
});

const groups = ref([]);
const langs = ref([]);
const tagsIds = ref([]);
const generatingMetaDesc = ref(false);


function smallLetters(tekst) {
  return tekst.toLowerCase();
}


const computedCity = computed(() => {
  if (article.value.city){
  const cityText = article.value.city;
  return smallLetters(cityText);
}
});


const showNextTag = (tagId) => {
  // console.log("showNextTag...", tagId)
  router.push({ name: "tag", params: { id: tagId } });
};




const fetchArticleData = async (id) => {
  try {
    const response = await fetch(`http://localhost:3000/article/${id}`);
    if (response.ok) {
      const data = await response.json();
      article.value = data.data;
      console.log("article.value fetchArticleData:", article.value);


      articleJson.value = JSON.parse(article.value.json)
      console.log("articleJson.value:", articleJson.value);
      // const articleJson = JSON.parse(dataJsonString);


    } else {
      throw new Error("Problem z pobraniem danych");
    }
  } catch (error) {
    console.error(error);
  }
};





onMounted(async () => {
  const id = route.params.id; 
  console.log(id);

  try {
    await fetchArticleData(id); 
  } catch (error) {
    console.error(error);
  }
});

watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      article.value.json = "";
      fetchArticleData(newId);
    }
  },
  { immediate: true }
);


function changeToUrlTypeString(str) {
  return str.toLowerCase().replace(/\s+/g, "-");
}


let exceptions = ["to", "for", "with"];

function titleCase(str, exceptions) {
  return str
    .split(" ")
    .map((word, index) => {
      if (index === 0 || !exceptions.includes(word.toLowerCase())) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.toLowerCase();
    })
    .join(" ");
}

function countCharactersWithEmojis(text = "") {
  // if (typeof input === 'undefined' || input === null) {
  //   // Obsługa przypadku, gdy input jest undefined lub null
  //   return 0; // lub inna odpowiednia wartość domyślna
  // }

  const splitText = Array.from(text);
  return splitText.length;
}





const iframeSrcdoc = computed(() => {
  return `
    <style>
      * {padding:0; margin:0; overflow:hidden}
      html,body {height:100%}
      img, button {position:absolute; width:100%; top:0; bottom:0; margin:auto}
      img {display:block; object-fit:cover; height:100%}
      button {
        background-color:transparent; 
        border:none; 
        width:68px; 
        z-index:10; 
        left:50%; 
        top:50%; 
        cursor:pointer;
        transform: translate(-50%, -50%);
      }
      .ytp-large-play-button-bg {fill:#f00;}
    </style>
    <a href='https://www.youtube.com/embed/${articleJson.value.body.videoId}?autoplay=1'>
      <img src='https://img.youtube.com/vi/${articleJson.value.body.videoId}/hqdefault.jpg' alt='${articleJson.value.body.h1}'>
      <button class='ytp-large-play-button ytp-button' aria-label='Odtwórz' title='Odtwórz'>
        <svg height='100%' version='1.1' viewBox='0 0 68 48' width='100%'>
          <path class='ytp-large-play-button-bg' d='M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.10-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z' fill='#f00'></path>
          <path d='M 45,24 27,14 27,34' fill='#fff'></path>
        </svg>
      </button>
    </a>
  `.trim();
});

</script>



<style scoped>
      .container,
      a {
        text-align: center;
      }
      .container {
        box-sizing: border-box; /* Dodaj to, aby paddingi były wliczane do szerokości */
        border-radius: 17px;
        padding: 55px 45px 75px;
        margin: 35px auto;
        background-color: #fff;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
          0 4px 6px -2px rgba(0, 0, 0, 0.05);
        width: 70vw;
        max-width: 750px;
      }
      p {
        text-align: left;
        line-height: 1.5rem;
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
      }
      h1{
        font-size: 2.2rem;
        font-weight: bold;
        display: block;
        font-size: 2em;
        margin-block-start: 0.67em;
        margin-block-end: 0.67em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
      }
      h2 {
        margin: 40px 0 20px 0;
        font-size: 1.8rem;
        font-weight: bold;
      }
      a {
        background-color: rgb(255 153 58);
        border: none;
        color: #fff;
        padding: 15px 72px;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        border-radius: 50px;
      }
      a:active,
      a:hover {
        background-color: rgb(255 153 58);
      }
      #all {
        position: fixed;
        bottom: 25px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 25px;
        background-color: #111;
        font-size: 16px;
        font-weight: 500;
      }
      #all:hover {
        background-color: rgb(255 153 58);
      }

      .video {
        border-radius: 0.75rem;
        width: 100%;
        max-width: 560px; /* Maksymalna szerokość dla większych ekranów */
        height: auto;
        aspect-ratio: 16 / 9; /* Zachowanie proporcji 16:9 */
      }

      .mark {
        color: #111;
        margin: 7px;
        padding: 0.1em 0.4em;
        border-radius: 0.8em 0.3em;
        background: transparent;
        background-image: linear-gradient(
          to right,
          rgba(255, 225, 0, 0.1),
          rgb(255 153 58) 4%,
          rgb(255 179 0 / 30%)
        );
        -webkit-box-decoration-break: clone;
        box-decoration-break: clone;
        margin-left: auto;
        margin-right: auto;
      }

      /* @counter-style repeating-emoji {
      system: cyclic;
      symbols: "\1F431" "\1F436" "\1F984"; 
      suffix: " ";
    } */
  

     .article ul {
        list-style-type: disc;
        padding: 0;
        margin: 0;
        background-color: red;
      }

      li,
      li a {
        background-color: #f3f4f6;
        font-size: 0.875rem;
        color: black;
        border-radius: 99px;
        padding: 0;
        margin: 0rem;
        display: inline-block;
      }
      li a {
        padding: 0.5rem 1.3rem;
        text-decoration: none;
      }

      li {
        margin-bottom: 10px;
        margin-right: 0.5rem;
        margin-left: 15px;
		    padding-left: 5px;
        
      }



   



      li:hover,
      li a:hover {
        /* background-color: #f3f4f6; */
        text-decoration: none;
        background-color: rgb(255 153 58);
      }

      .summary {
        margin-top: 35px;
        background-color: rgb(255, 245, 235);
        padding: 2rem;
        border-radius: 14px;
      }

      .summary h2 {
        margin: 0;
        text-align: left;
        color: rgb(140, 61, 0);
      }

      .wystapili {
        margin-top: 35px;
      }
      .wystapili h2 {
        margin-bottom: 25px;
      }

      .close-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 12px; 
        margin-top: -12px; 
        position: relative;
      }

      a.close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        padding: 6px;
        background-color: #f3f4f6;
        color: #111;
        font-size: 1.4rem;
        border-radius: 9999px;
        cursor: pointer;
        transition: background-color 300ms, color 300ms;
        position: absolute;
        right: -3rem;
        top: -2rem;
        font-weight: 600;

      }

      a.close:hover {
        background-color: #d1d5db;
      }


      @media (max-width: 768px) {
        .container {
          padding: 55px 25px 25px;
          width: 100%;
          margin: 15px auto; 
        }
        .video {
          max-width: 560px; 
        }

        .close {
          right: -1.5rem;
          top: -2rem;
        }
      }


</style>
